export type TennisScoreType =
{
    servs: number;

    player1Points: any;
    player2Points: any;

    player1Games: any;
    player2Games: any;

    player1Set1: any;
    player1Set2: any;
    player1Set3: any;
    player1Set4: any;
    player1Set5: any;

    player2Set1: any;
    player2Set2: any;
    player2Set3: any;
    player2Set4: any;
    player2Set5: any;

    scoreSetsPlayer1: number;
    scoreSetsPlayer2: number;

    matchType: any;
    lastSetIsAdvantageSet: number;
}

export class TennisScore {
    servs: number = -1;

    player1Points: any = "";
    player2Points: any = "";

    player1Games: any = "";
    player2Games: any = "";

    player1Set1: any  = "";
    player1Set2: any  = "";
    player1Set3: any  = "";
    player1Set4: any = "";
    player1Set5: any  = "";

    player2Set1: any  = "";
    player2Set2: any  = "";
    player2Set3: any  = "";
    player2Set4: any  = "";
    player2Set5: any = "";

    scoreSetsPlayer1: number = 0;
    scoreSetsPlayer2: number = 0;

    matchType: any = 3;
    lastSetIsAdvantageSet: number = 0;

    constructor (tennisScore: TennisScoreType)
    {
        this.servs = tennisScore.servs;

        this.player1Points = tennisScore.player1Points;
        this.player2Points = tennisScore.player2Points;

        this.player1Games = tennisScore.player1Games;
        this.player2Games = tennisScore.player2Games;

        this.player1Set1 = tennisScore.player1Set1;
        this.player1Set2 = tennisScore.player1Set2;
        this.player1Set3 = tennisScore.player1Set3;
        this.player1Set4 = tennisScore.player1Set4;
        this.player1Set5 = tennisScore.player1Set5;

        this.player2Set1 = tennisScore.player2Set1;
        this.player2Set2 = tennisScore.player2Set2;
        this.player2Set3 = tennisScore.player2Set3;
        this.player2Set4 = tennisScore.player2Set4;
        this.player2Set5 = tennisScore.player2Set5;

        this.scoreSetsPlayer1 = tennisScore.scoreSetsPlayer1;
        this.scoreSetsPlayer2 = tennisScore.scoreSetsPlayer2;

        this.matchType = tennisScore.matchType;
        this.lastSetIsAdvantageSet = tennisScore.lastSetIsAdvantageSet;
    }

    public static createEmptyTennisScore(): TennisScore
    {
        return new TennisScore(
            {
                servs: -1,
                player1Points: "",
                player2Points: "",
                player1Games: "",
                player2Games: "",
                player1Set1: "",
                player1Set2: "",
                player1Set3: "",
                player1Set4: "",
                player1Set5: "",
                player2Set1: "",
                player2Set2: "",
                player2Set3: "",
                player2Set4: "",
                player2Set5: "",
                scoreSetsPlayer1:  0,
                scoreSetsPlayer2:  0,
                matchType:  3,
                lastSetIsAdvantageSet:  0
            }
        )
    }

}